var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TextField, Typography, InputAdornment, styled } from "@mui/material";
import { useState } from "react";
import theme from "../../theme";
import './SearchBox.css';
import { jsx as _jsx } from "react/jsx-runtime";
var SearchBoxTypography = styled(Typography)({ '&.MuiTypography-root': { paddingTop: '.75rem', textOverflow: 'ellipsis' } });
var SearchBoxTextField = styled(TextField)({ '& .MuiInputBase-root': { background: theme.palette.rnMisc.white, paddingRight: 0 }, '& .MuiInputBase-input': { padding: '8px' }, '& .Mui-focused .MuiOutlinedInput-notchedOutline ': { borderColor: "".concat(theme.palette.rnSteel.steel700, " !important") }, '& .MuiInputBase-root .MuiInputAdornment-root': { cursor: 'pointer !important' } });
var StyledInputAdornment = styled(InputAdornment)({ '& .MuiInputAdornment-root': { cursor: 'pointer !important' }, '& .MuiInputAdornment-root:hover': { cursor: 'pointer !important' } });
export var SearchBox = function (_a) {
    var label = _a.label, value = _a.value, setValue = _a.setValue, search = _a.search, restrictKeyPress = _a.restrictKeyPress, _b = _a.errMsg, errMsg = _b === void 0 ? '' : _b;
    var _c = useState(false), focused = _c[0], setFocused = _c[1];
    var handleFocus = function (event) { setFocused(true); };
    var handleBlur = function (event) { setFocused(false); };
    var handleChange = function (event) { if (event.target.value === '' || !restrictKeyPress || restrictKeyPress.test(event.target.value)) {
        setValue(event.target.value);
    } };
    var searchHandler = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, search(value)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    }); }); };
    var handleKeyDown = function (event) { if (event.key === 'Enter') {
        searchHandler();
    } };
    return /*#__PURE__*/ _jsx("div", { id: "QuickSearch", children: /*#__PURE__*/ _jsx(SearchBoxTextField, { placeholder: label || "Enter Assembly #", className: "w-100", type: "text", "aria-labelledby": "SearchAssembly", value: value, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, onKeyDown: handleKeyDown, helperText: errMsg, InputProps: { endAdornment: /*#__PURE__*/ _jsx(StyledInputAdornment, { position: "start", onClick: function () { return searchHandler(); }, children: /*#__PURE__*/ _jsx(FontAwesomeIcon, { icon: "search", color: theme.palette.rnOrange.darkOrange }) }) } }) });
};
